



























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";
import { IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "ticket-form": () =>
      import("@/components/app/global/tickets/ticketForm.vue")
  }
})
export default class AddTicketModal extends Vue {
  public $refs!: {
    form: HTMLFormElement;
  };

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public accountId!: IAccount["id"];

  @Prop({ default: null })
  public leadId!: IClient["id"];

  @Prop({ required: true })
  public brandId!: IClient["brand_id"];

  @Prop({ default: () => ({}) })
  public contractProduct!: IContractProduct;

  public isProcessing = false;
  public formIsNotValid = false;

  public isProcessingChange(value) {
    this.isProcessing = value;
  }
}
